import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {useContainerStore} from "@domains/dashboard/stores/container.store";

export const getContainersResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {

    const workspaceStore = useWorkspaceStore();
    const containerStore = useContainerStore();

    containerStore.loadContainers({workspaceId: workspaceStore.getSelectedWorkspaceId})
        .then(() => next())

};
